import React from "react";
import { connect } from "react-redux";
import { AppState } from "src/redux/store";
import {Project, StatusProject} from "src/redux/projects";
import ArchivedProjectsList from "src/components/ArchivedProjectsList";
import { withNamespaces, WithNamespaces } from "react-i18next";
import * as Stories from "src/redux/stories";
import { Loader } from "src/components/Loader";

import { HeaderPage } from "src/components/HeaderPage";

interface ProjectsByYear {
  year: string;
  projects: Project[];
}

function mapStateToProps(state: AppState) {
  return {
     projects: state.projects.projects.filter(
        p => p.status === StatusProject.Deliver
    ),
    isLoading: state.projects.isLoadingProjects
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchArchivedProjects: () => dispatch(Stories.fetchProjectsListOnce())
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  WithNamespaces;

/**
 * Main container of our app, handle common logic:
 * showing available apps etc...
 */
class ArchivedProjectsContainerToConnect extends React.Component<Props> {
  componentWillMount() {
    this.props.fetchArchivedProjects();
  }

  render() {
    if (this.props.isLoading) {
      return <Loader />;
    }

    // Keep project having at least one delivery
    /*const projects = this.props.projects.filter(projet => {
      return (
        projet.prestations.find(presta => presta.deliveryId != null) != null
      );
    });*/

    // Sort projects by financial year
    const projectsByYears = this.props.projects.reduce<ProjectsByYear[]>(
      (acc, project) => {
        if (!project.financialYear) {
          return acc;
        }

        const year = acc.find(a => a.year === project.financialYear);

        if (!year) {
          acc.push({
            year: project.financialYear,
            projects: [project]
          });
        } else {
          year.projects.push(project);
        }

        return acc;
      },
      [] as ProjectsByYear[]
    );

    // Order by years desc
    projectsByYears.sort((a, b) => +b.year - +a.year);

    return (
      <div>
        <div className="mb-4">
          <HeaderPage title={this.props.t("library.title")} />
        </div>
        {projectsByYears.map(y => (
          <div key={y.year}>
            <h2 className="mb-3">
              {this.props.t("library.projects")}{" "}
              <span className="date">{+y.year + 2000}</span>
            </h2>
            <ArchivedProjectsList projects={y.projects} />
          </div>
        ))}
      </div>
    );
  }
}

export const ArchivedProjectsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(ArchivedProjectsContainerToConnect));



// WEBPACK FOOTER //
// ./src/containers/ArchivedProjectsContainer.tsx